import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardPublicComponent } from './dashboard-public/dashboard-public.component';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { LabelModule } from '../utilities/label/label.module';
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { AutocompleteEditModule } from '../utilities/autocomplete-edit/autocomplete-edit.module';
import { DateEditModule } from '../utilities/date-edit/date-edit.module';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { ToastModule } from 'primeng/toast';
import { ProgressBarModule } from 'primeng/progressbar';
import { DashboardDetalhesComponent } from './dashboard-public/dashboard-detalhes/dashboard-detalhes.component';



@NgModule({
  declarations: [
    DashboardPublicComponent,
    DashboardDetalhesComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    LabelModule,
    CardModule,
    InputTextModule,
    DropdownModule,
    DateEditModule,
    MultiSelectModule,
    MessageModule,
    MessagesModule,
    ToastModule,
    ProgressBarModule
  ],
  exports: [
    DashboardPublicComponent
  ]
})
export class DashboardModule { }
